import { createSelector } from '@reduxjs/toolkit'

const getError = state => state.error

export const selectErrorList = createSelector([getError], error => error.list)

export const selectErrorMessage = (state, error) => {
  const errorList = selectErrorList(state).filter(item => item && item.key === error)
  return errorList.length ? errorList[0].message : ''
}

export const selectError = (state, error) => {
  return selectErrorList(state).filter(item => item && item.key === error)[0]
}

export const selectErrorByKey = key => state =>
  selectErrorList(state).filter(i => i && i.key === key)[0]
